module.exports = __webpack_public_path__ + "img/apidays-hongkong-2022-agenda-0824.d1b41b17.png";